/**
 * 拉取 mock 数据
 * @return {Promise<*>|Promise<void>}
 */
export default function fetchMock() {
  if (DEPLOY_ENV !== 'master' && window.location.href.indexOf('__MOCK__') > -1) {
    return require('./intercept-jsonp-with-mocks').default(require('@src/services/zt/mock.json'));
  }
  return Promise.resolve();
}
